import { useCheckboxState } from '../abstract/checkbox';

export function useFlatletFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { checked: flatlet, setChecked: onFlatletChange } = useCheckboxState({
    defaultValue: query.flatlet,
    filterKey: `flatlet`,
    setFilters,
    updateQuery,
  });

  return { flatlet, onFlatletChange };
}
